const RouteSecurity = (router, store) => {
  let hasPermission = store.getters['user/hasPermission']
  let isConnected = store.getters['user/isConnected']
  let getRedirectRoute = (expectedCredentials, to) => {
    let loginTest = /^\/login/g
    if (to.fullPath && !loginTest.test(to.fullPath) && to.fullPath !== '/') {
      return { name: 'user-login', query: { path: to.fullPath } }
    }
    return { name: 'user-login' }
  }

  // Guard security access of page
  router.beforeEach((to, from, next) => {
    if (process.env.VUE_APP_DEV_FORCE_LOGIN === 'true') {
      return next()
    }
    if (!to.meta || !to.meta.credentials) {
      // console.warn('No credential found on route meta')
      return next()
    }
    // If credential is an array, check if one of all credentials exists
    if (typeof to.meta.credentials === 'object') {
      // If empty object, juste stay connected
      if (!Object.keys(to.meta.credentials).length) {
        if (isConnected()) {
          return next()
        }
        return next(getRedirectRoute(to.meta.credentials, to))
      }
      if (to.meta.credentials.filter((credential) => hasPermission(credential)).length > 0) {
        return next()
      }
      return next(getRedirectRoute(to.meta.credentials, to))
    }

    // If an object, execute function
    if (typeof to.meta.credentials === 'function') {
      return to.meta.credentials(hasPermission, next, (credentials) => getRedirectRoute(typeof credentials === 'object' ? credentials : [credentials], to), to, store)
    }

    throw Error('Invalid to.meta.credentials object. You must use an array of string credential or a function')
  })
}

export default RouteSecurity
